import * as z from 'zod';

/** RFC 9457 problem details — the body of every error response. */
export const ProblemSchema = z
  .object({
    type: z.string().meta({ example: 'https://deli.crm/problems/validation' }),
    title: z.string(),
    status: z.number().int(),
    detail: z.string().optional(),
    instance: z.string().optional(),
    requestId: z.string().optional(),
    errors: z
      .array(z.object({ path: z.string(), message: z.string() }))
      .optional()
      .meta({ description: 'Field-level validation errors' }),
  })
  .meta({ id: 'Problem' });

export type Problem = z.infer<typeof ProblemSchema>;

export const problemResponse = (description: string) => ({
  description,
  content: { 'application/problem+json': { schema: ProblemSchema } },
});
